import React, { Component } from 'react';
import 'whatwg-fetch';
class getLoginUser extends Component {
  constructor(){
    super();
    this.state = {
        correo_electronico:'',
        contrasenia:'',
        msg:''
    }
  }
  validateEmail = (email) => {
      return /^[A-Za-z0-9._%-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/.test(email)

  }
  getValite =()=>{
    const mail = this.state.correo_electronico.trim()
    const password = this.state.contrasenia.trim()
    if(mail.trim()===''){
      this.setState({
        msg : "Ingrese Mail"
      })
      return
    }
    if(!this.validateEmail(mail)){
      this.setState({
        msg : "Mail Incorrecto"
      })
      return
    }

    if(password.trim()===''){
      this.setState({
        msg : "Ingrese Contraseña"
      })
      return
    }

    const url= this.props.dir_url + "webapp/getValiteUser";
    const token =  this.props.token

    var obj = { accion:'validate', token, mail, password};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      //console.log(data)
      if(data[0].status==="ok"){
        this.props.setTokenClient(data[0].msg[0].uuid_cliente)
      }else{
        this.setState({
          msg : "Mail o Contraseña incorrecta"
        })
      }
      this.props.get_loading(false)
    })
    .catch(console.log)
    this.props.get_loading(true)
  }

  inputChangedHandlerText2 = (event) => {
    this.setState({
      correo_electronico :event.target.value
    })
  }

  inputChangedHandlerText3 = (event) => {
    this.setState({
      contrasenia :event.target.value
    })
  }
  render() {
    return (
      <div className="cssversion_menu cssversion_colorblanco">
        <div className="cssversion_pw100 cssversion_pxh50" style={{"display":"flex"}}>
          <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') } onClick={ () => this.props.get_go_to('')} />
          </div>
          <div className="cssversion_pw85 cssversion_pxh50 cssversion_contentRight">
            <span className="span-global-link" onClick={ () => this.props.get_go_to('registre_new')}>Regístrate</span>
          </div>
        </div>
        <div className="cssversion_pw100 cssversion_pxh100 cssversion_contentCenter" style={{"display":"flex"}}>
          <span className="span-global-title">Iniciar sesión</span>
        </div>
        <div className="cssversion_pw100">
          <div className="cssversion_pw100 cssversion_pxh50" style={{"display":"flex"}}>
            <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
               <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/16467180181582004498-128.png') } />
            </div>
            <div className="cssversion_pw85 cssversion_pxh50 cssversion_contentCenter">
              <input value={this.state.correo_electronico} onChange={(event)=>this.inputChangedHandlerText2(event)} className="input-global cssversion_pw90" placeholder="Correo Electrónico o Celular" />
            </div>
          </div>
          <div className="cssversion_pw100 cssversion_pxh50" style={{"display":"flex"}}>
            <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
               <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/469704211582004494-128.png') } />
            </div>
            <div className="cssversion_pw85 cssversion_pxh50 cssversion_contentCenter">
              <input type="password" value={this.state.contrasenia} onChange={(event)=>this.inputChangedHandlerText3(event)} className="input-global cssversion_pw90" placeholder="Contraseña" />
            </div>
          </div>
          <div className="cssversion_pw100 cssversion_pxh100 cssversion_contentCenter">
            <button className="button-global cssversion_pw85" onClick={ () => this.getValite()}>
              INICIAR SESIÓN
            </button>
          </div>
          <div className="cssversion_pw100 cssversion_pxh50 cssversion_contentCenter">
            {(this.state.msg)?
            <div className="cssversion_pw85 cssversion_pxh50 cssversion_contentCenter" style={{"display":"flex","backgroundColor":"#f44336","borderRadius": "15px"}}>
              <span className="span-global-link" style={{"color":"white"}}>{this.state.msg}</span>
            </div>
            :''}
          </div>
        </div>
      </div>
    )
  }
}
export default getLoginUser;
